import {BaseLinkModelSettings} from "../../infrastructure/models/link/base-link-model-settings";
import {HISTORY_ACTIONS} from "../consts";
import {BaseManager} from "../../infrastructure/managers/base-manager";
import {singleton} from "../../infrastructure/decorators/singleton";

@singleton
export class HistoryManager extends BaseManager {
  navigate;
  location: Location;
  screens = [];
  initialized = false;
  routeChangeHandlers: Array<Function> = [];

  static injectables = [...BaseManager.injectables];

  initHistory(navigate, location) {
    this.navigate = navigate;
    this.location = location;

    this.initialized = true;
  }

  trackLocation(location: Location) {
    if (!this.currentLocation || this.currentLocation.pathname !== location.pathname) {
      this.routeChangeHandlers.forEach((handler) => handler(location.pathname)); // Trigger route change handlers
      this.currentLocation = location; // Save current location
    }
  }

  get hasBack() {
    return this.screens.length > 0;
  }

  get locationState(): BaseLinkModelSettings {
    return this.location.state
  }

  get action(): HISTORY_ACTIONS {
    return this.location.action;
  }

  goBack() {
    this.navigate(-1);
  }

  push(url) {
    this.onPush(url);
    this.navigate(url, { replace: false });
  }

  onPush(url) {
    this.screens.push(url);
  }

  pop() {
    this.goBack();
  }

  onPop() {
    this.screens.pop();
  }

  replace(url) {
    this.navigate(url, { replace: true });
  }

  get currentPath() {
    return this.location?.pathname + this.location?.hash;  }

  get currentPathParams() {
    return this.currentPath.split('/').filter(x => x);
  }

  get currentRoute() {
    return this.location?.href;
  }

  get currentScreen() {
    return this.screens[this.screens.length - 1];
  }

  registerToRouteChanged(func) {
    this.routeChangeHandlers.push(func);
  }

  get search() {
    const pairs = window.location.search.substring(1).split("&");
    const obj = {};
    let pair;

    for (const i in pairs) {
      if (pairs[i] === "") continue;

      pair = pairs[i].split("=");
      obj[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }

    return obj;
  }

  clearState() {
    this.navigate(this.location.pathname, { state: {} });

  }
}

